import React from 'react';
import { get, post, del } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Input } from 'reactstrap';
import { Buffer } from 'buffer';

import UserContext from './UserContext';
import { messageCode } from './MessageCode';
import { Service, LinkedService } from './components/LinkedService';
import { Confirmation } from './components/Confirmation';

class LinkConfig extends React.Component {
  static contextType = UserContext;
  values = null;
  mfa = false;
  state = {
    errorMessage: null,
    warnMessage: null,
    serviceList: [],
    linkedService: [],
    selectService: '00',
    confirmRegist: false,
    confirmRelease: false,
  };

  async componentDidMount() {
    this.getData();
    this.regCoLinkAuth();
  }

  async regCoLinkAuth() {
    try {
      const qs = new URLSearchParams(window.location.search);

      const responseErrorCode = qs.get('error');
      if (responseErrorCode) {
        this.setState({ errorMessage: messageCode['E1'.concat(responseErrorCode)] });
        return;
      }

      const state = qs.get('state'),
        authorization_code = qs.get('authorization_code'),
        portal_user_no = qs.get('portal_user_no'),
        link_system_cd = qs.get('link_system_cd'),
        hyoji_mei_knj = qs.get('hyoji_mei_knj');

      if (!(state && authorization_code && portal_user_no && link_system_cd && hyoji_mei_knj)) {
        return;
      }

      const params = {
        headers: {
          Authorization: `Bearer ${(await fetchAuthSession()).tokens?.idToken}`,
        },
        body: {
          state: state,
          authorization_code: authorization_code,
          portal_user_no: Number(portal_user_no),
          link_system_cd: link_system_cd,
          hyoji_mei_knj: hyoji_mei_knj,
          rec_mod_pgm_id: 'P203001',
        },
      };
      const op = post({ apiName: 'HelloOGAPI', path: '/credential', options: params });
      await op.response;
      window.location.replace('/link');
    } catch (err) {
      // errのレスポンスもJSONに変換
      let resultCode = null;
      try {
        const responseBody = JSON.parse(err.response.body);
        resultCode = responseBody.resultCode;
      } catch (e) {
        this.setState({ errorMessage: messageCode['E0001'] });
      }

      if (err.response && 'statusCode' in err.response && resultCode) {
        this.setState({ errorMessage: messageCode[resultCode] });
      } else {
        this.setState({ errorMessage: messageCode['E0001'] });
      }
      return;
    }
  }

  async getData() {
    // サービス一覧の取得
    get({
      apiName: 'HelloOGAPI',
      path: '/master/service',
    })
      .response.then((response) => response.body.json())
      .then((data) => {
        const list = [{ code: '00', disp: '選択してください', img: '', mfa: false }];
        data.results.forEach((element) => {
          list.push({
            code: element.link_system_cd,
            disp: element.link_system_nm_knj,
            img: element.logo_image_path,
            mfa: element.nidankai_auth_hissu_sgn,
          });
        });
        this.setState({ serviceList: list });
      })
      .catch(() => {
        this.setState({ errorMessage: messageCode['E0001'] });
      });
    // ポータルユーザー連携済サービス情報取得
    get({
      apiName: 'HelloOGAPI',
      path: '/portaluser/linkedservice',
      options: {
        headers: {
          Authorization: `Bearer ${(await fetchAuthSession()).tokens?.idToken}`,
        },
        queryParams: {
          portal_user_no: Number(this.context.user.attributes['custom:user_no']),
        },
      },
    })
      .response.then((response) => response.body.json())
      .then((data) => {
        this.setState({ linkedService: data.results });
      })
      .catch((err) => {
        // errのレスポンスもJSONに変換
        let resultCode = null;
        try {
          const responseBody = JSON.parse(err.response.body);
          resultCode = responseBody.resultCode;
        } catch (e) {
          this.setState({ errorMessage: messageCode['E0001'] });
        }

        if (err.response && 'statusCode' in err.response && resultCode) {
          this.setState({ errorMessage: messageCode[resultCode] });
        } else {
          this.setState({ errorMessage: messageCode['E0001'] });
        }
      });
    // ユーザーデータの取得
    get({
      apiName: 'HelloOGAPI',
      path: '/portaluser',
      options: {
        headers: {
          Authorization: `Bearer ${(await fetchAuthSession()).tokens?.idToken}`,
        },
        queryParams: {
          portal_user_no: Number(this.context.user.attributes['custom:user_no']),
        },
      },
    })
      .response.then((response) => response.body.json())
      .then((data) => {
        this.mfa = data.results.nidankai_auth_yohi_sgn;
      })
      .catch((err) => {
        // errのレスポンスもJSONに変換
        let resultCode = null;
        try {
          const responseBody = JSON.parse(err.response.body);
          resultCode = responseBody.resultCode;
        } catch (e) {
          this.setState({ errorMessage: messageCode['E0001'] });
        }

        if (err.response && 'statusCode' in err.response && resultCode) {
          this.setState({ errorMessage: messageCode[resultCode] });
        } else {
          this.setState({ errorMessage: messageCode['E0001'] });
        }
      });
  }

  render() {
    const { serviceList, linkedService, selectService, confirmRegist, confirmRelease } = this.state;
    return (
      <div className="form-col">
        <div className="row justify-content-center no-gutters pl-4 pr-4">
          <div className="col-lg-9">
            <p>
              こちらから、トップページの各種リンク欄に各種サービスへのログイン用のリンクバナーの設定が可能です。
              <br />
              こちらでID・PWをご設定いただくと次回からご入力いただく必要はございません。
              <br />
              リンクバナーの設定可能なサービスは下記のリンクするサービスよりご確認ください。
            </p>
            <p>※二段階認証を必須とするリンクバナーを利用する場合は二段階認証の設定を有効にしてください</p>
            <p>※最大50件のサービスの設定が可能です</p>
            <div className="error-message">
              <p>{this.state.errorMessage}</p>
            </div>
            <div className="area-title mt-5">
              <h2>リンクするサービス</h2>
              <div className="form-label-group pb-4">
                <Input
                  className="form-control"
                  type="select"
                  onChange={(e) => {
                    let msgcode = null;
                    if (e.target.value !== '00') {
                      if (this.mfa === false && serviceList[Number(e.target.value)].mfa === true) {
                        msgcode = messageCode['E0017'];
                      }
                    }
                    this.setState({ selectService: e.target.value, warnMessage: msgcode });
                  }}
                  disabled={linkedService.length > 50}
                >
                  {serviceList.map((item, index) => (
                    <option key={index} value={item.code}>
                      {item.disp}
                    </option>
                  ))}
                </Input>
                {this.state.warnMessage && (
                  <div className="error-message">
                    <p>{this.state.warnMessage}</p>
                  </div>
                )}
              </div>
              <Service
                serviceCode={selectService}
                imagePath={selectService !== '00' ? serviceList[Number(selectService)].img : ''}
                onRegist={(target) => {
                  this.registTarget = target;
                  this.setState({ confirmRegist: true });
                }}
                disabled={
                  this.mfa === false && (selectService !== '00' ? serviceList[Number(selectService)].mfa : false)
                }
              />
              <Confirmation
                show={confirmRegist}
                message="リンク登録してよろしいですか？"
                onApply={async () => {
                  // 認証情報生成システムリクエスト
                  try {
                    const params = {
                      portal_user_no: Number(this.context.user.attributes['custom:user_no']),
                      link_system_cd: this.registTarget.systemCd,
                      hyoji_mei_knj: this.registTarget.dispName,
                    };
                    const strParams = Buffer.from(JSON.stringify(params))
                      .toString('base64')
                      .replace(/\+/g, '-')
                      .replace(/\//g, '_')
                      .replace(/=+$/, '');
                    const url = `${process.env.REACT_APP_WAB_URL}/login/index.php?action_login=true&p=${process.env.REACT_APP_AUTH_GENERATE_URL}/eneAuth/registerTempAuthInfo?params=${strParams}`;
                    window.location.replace(url);
                  } catch (err) {
                    this.setState({ errorMessage: messageCode['E0001'] });
                    return;
                  }
                }}
                onHide={() => this.setState({ confirmRegist: false })}
              />
            </div>
            <div className="area-title mt-5">
              <h2>リンク済みサービス一覧</h2>
            </div>
            <div className="service-link pl-4 pr-4">
              {linkedService.map((item, index) => (
                <LinkedService
                  key={index}
                  serviceCode={item.link_system_cd}
                  dispName={item.hyoji_mei_knj}
                  authID={item.link_system_id}
                  imagePath={item.logo_image_path}
                  onRelease={(target) => {
                    this.releaseTarget = target;
                    this.setState({ confirmRelease: true });
                  }}
                />
              ))}
              <Confirmation
                show={confirmRelease}
                message="リンク解除してよろしいですか？"
                onApply={async () => {
                  this.setState({ confirmRelease: false });
                  const param = {
                    headers: {
                      Authorization: `Bearer ${(await fetchAuthSession()).tokens?.idToken}`,
                    },
                    body: {
                      portal_user_no: Number(this.context.user.attributes['custom:user_no']),
                      link_system_cd: this.releaseTarget.systemCd,
                      link_system_id: this.releaseTarget.systemId,
                    },
                  };
                  del({
                    apiName: 'HelloOGAPI',
                    path: '/credential',
                    options: param,
                  })
                    .response.then(() => {
                      this.getData();
                    })
                    .catch((err) => {
                      // errのレスポンスもJSONに変換
                      let resultCode = null;
                      try {
                        const responseBody = JSON.parse(err.response.body);
                        resultCode = responseBody.resultCode;
                      } catch (e) {
                        this.setState({ errorMessage: messageCode['E0001'] });
                      }

                      if (err.response && 'statusCode' in err.response && resultCode) {
                        this.setState({ errorMessage: messageCode[resultCode] });
                      } else {
                        this.setState({ errorMessage: messageCode['E0001'] });
                      }
                    });
                }}
                onHide={() => this.setState({ confirmRelease: false })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default LinkConfig;
